export const BasedOn = {
  PreferredTopics: 'PREFERRED_TOPICS'
};
export const Pricing = {
  Free: 'FREE',
  Paid: 'PAID',
  All: 'ALL'
};
export const Provider = {
  WixPublicMedia: 'WIX_PUBLIC_MEDIA',
  Shutterstock: 'SHUTTERSTOCK',
  Unsplash: 'UNSPLASH'
};